import React, { useEffect,useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";


const Accordion = ({ heading, content }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <li className="accordion-item">
      <div className="accordion-toggle" onClick={() => setIsActive(!isActive)}>
        <h3>{heading}</h3><span>{isActive ? "-" : "+"}</span>
      </div>
      {isActive && <div className="accordion-content">{content}</div>}
    </li>
  );
};

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const Experiments = () => {
  const headers = ['Research', 'Experimental materials', 'Preparing the Aspergillus oryzae culture', 'Preparing_ protoplasts', 'Transformation', 'ANTICANCER Experiments','Design of future in vivo experiments'];
  
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1> Experiments</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
               Experiments
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header=>{
                   
                  return (
                    <li><a href={"#"+header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )
                  
                })
              }
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <div style={{display:'none'}}>
          {
            headers.map(header => {
              return (
                <section href={header.split(' ')[0]}>{
                  header
                }</section>
              )

            })
          }
          </div>
          
          <div>
            <div>
              <section id="Research">
                <h1>Research</h1>
                
                <p>In this part, a fungus culture from the species <em>Aspergillus oryzae</em> is transformed<strong> by CRISPR. The main focus of CRISPR in this project is to insert two genes from two different fungi other than </strong><strong><em>A. oryzae</em></strong><strong>: </strong><span className="highlight"><em>NsrO</em></span> from the <em>nsr</em> gene cluster, and <span className="highlight"><em>AacuE</em></span> from the <em>Aacu</em> gene cluster.&nbsp;</p>
                <p>The <em>nsr </em>gene cluster allows <em>A. oryzae</em> to <strong>produce blennolides</strong>, which are a group of compounds with bioactivity such as anti-cancer effects. <em>Aacu</em> gene cluster allows it to <strong>dimerize blennolides</strong>, allowing the substance to be more anticancer potent in terms of bioactivity.</p>

                <p><h1>Experiments</h1></p>
                {/* <a href={Pdf} target="_blank"><h1>  </h1></a> */}
                
                <a href="https://static.igem.wiki/teams/4154/wiki/assets/peg-mediated-transformation-protocol.pdf" target="_blank" className="Download">Download the protocol of <em>Aspergillus oryzae</em> Transformation </a>
                

              </section>
              <br />
              <section id="Experimental">
                <Accordion heading={"Experimental materials"} content={
                <ul>
                  <li>
                    <p>DPY medium</p>
                    <ul>
                      <li>
                        <p>dextrin: 20 g (2% w/v)</p>
                      </li>
                      <li>
                        <p>Hipoly peptone: 10 g (1% w/v)</p>
                      </li>
                      <li>
                        <p>yeast extract: 5 g (0.5% w/v)</p>
                      </li>
                      <li>
                        <p>MgSO4·7H2O: 0.5 (0.05% w/v)</p>
                      </li>
                      <li>
                        <p>KH2PO4: 5 g (0.5 w/v)</p>
                      </li>
                      <li>
                        <p>If necessary: Adenine: 100 mg (0.01% w/v)</p>
                      </li>
                      <li>
                        <p>Milli-Q Water: up to 1 L</p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>TF solution 0</p>
                    <ul>
                      <li>
                        <p>maleic acid: 1.16 g ([ ]fin.=50 mM)</p>
                      </li>
                      <li>
                        <p>milli Q: make up to 200 ml</p>
                      </li>
                      <li>
                        <p>adjust the pH to 5.5</p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>TF solution 1 (15 ml tube)&nbsp;</p>
                    <ul>
                      <li>
                        <p>yatalase: 0.1 g ([ ]fin.=0.1%)</p>
                      </li>
                      <li>
                        <p>(NH4)2SO4: 0.79 g ([ ]fin.= 0.6 M)</p>
                      </li>
                      <li>
                        <p>TF solution 0 make up to 10 ml</p>
                      </li>
                      <li>
                        <p>filter with 0.22 μm millipore filter (transfer to 50 ml tube)&nbsp;</p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>TF solution 2</p>
                    <ul>
                      <li>
                        <p>sorbitol: 87.4 g ([ ]fin.= 1.2 M)</p>
                      </li>
                      <li>
                        <p>CaCl2·2H2O: 2.94 g ([ ]fin.= 50 mM)</p>
                      </li>
                      <li>
                        <p>NaCl: 0.82 g ([ ]fin.= 35 mM)</p>
                      </li>
                      <li>
                        <p>1M Tris-HCl (pH 7.5): 4 ml ([ ]fin.:10 mM)</p>
                      </li>
                      <li>
                        <p>Milli-QWater: make up to 400 ml</p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>TF solution 3</p>
                    <ul>
                      <li>
                        <p>PEG 4000: 120 g ([ ]fin.= 60%)</p>
                      </li>
                      <li>
                        <p>CaCl2·2H2O: 1.47 g ([ ]fin.=50 mM)</p>
                      </li>
                      <li>
                        <p>1M Tris-HCl: 2 ml ([ ]fin.= 10 mM)</p>
                      </li>
                      <li>
                        <p>Milli-Q Water: make up to 200 ml&nbsp;</p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>CD medium (bottom layer)+sor</p>
                    <ul>
                      <li>
                        <p>NaNO3: 0.6 g</p>
                      </li>
                      <li>
                        <p>KCl: 0.4 g</p>
                      </li>
                      <li>
                        <p>KH2PO4: 0.2 g</p>
                      </li>
                      <li>
                        <p>MgSO4·7H2O: 0.1 g</p>
                      </li>
                      <li>
                        <p>2% FeSO4·7H2O: 0.004 g</p>
                      </li>
                      <li>
                        <p>Glucose: 4 g</p>
                      </li>
                      <li>
                        <p>sorbitol: 43.72 g</p>
                      </li>
                      <li>
                        <p>adjust pH to 5.5</p>
                      </li>
                      <li>
                        <p>agar: 4.0 g&nbsp;</p>
                      </li>
                      <li>
                        <p>Milli-Q Water: add up to 200 ml</p>
                      </li>
                      <li>
                        <p>If necessary: Arginine: 0.2 g (0.1%)&nbsp;</p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Methionine: 0.3 g (0.15%)&nbsp;</p>
                  </li>
                  <li>
                    <p>Adenine: 0.02 g (0.01%)&nbsp;</p>
                    <ul>
                      <li>
                        <p>CD medium (top layer)+sor</p>
                        <ul>
                          <li>
                            <p>NaNO3: 0.3 g</p>
                          </li>
                          <li>
                            <p>KCl: 0.2 g&nbsp;</p>
                          </li>
                          <li>
                            <p>KH2PO4: 0.1 g</p>
                          </li>
                          <li>
                            <p>MgSO4·7H2O: 0.05 g</p>
                          </li>
                          <li>
                            <p>2% FeSO4·7H2O: 0.002 g</p>
                          </li>
                          <li>
                            <p>Glucose: 2 g</p>
                          </li>
                          <li>
                            <p>sorbitol: 21.86 g</p>
                          </li>
                          <li>
                            <p>adjust pH to 5.5</p>
                          </li>
                          <li>
                            <p>agar: 0.8 g</p>
                          </li>
                          <li>
                            <p>Milli-Q Water: add up to 100 ml</p>
                          </li>
                          <li>
                            <p>If necessary: Arginine: 0.2 g (0.1%)&nbsp;</p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Methionine: 0.3 g (0.15%)&nbsp;</p>
                  </li>
                  <li>
                    <p>Adenine: 0.02 g (0.01%)</p>
                  </li>
                  <li>
                    <p>Other things that need to be autoclaved</p>
                    <ul>
                      <li>
                        <p>Spatula</p>
                      </li>
                      <li>
                        <p>Cotton-stopped syringe</p>
                      </li>
                      <li>
                        <p>Filter with miracloth</p>
                      </li>
                      <li>
                        <p>Tips</p>
                      </li>
                    </ul>
                  </li>
                </ul>
                } />
                
              </section>
              <section id="Preparing">
                <Accordion heading={<>Preparing the&nbsp;<em>Aspergillus oryzae</em>&nbsp;culture</>} content={
                  <ol>
                    <li>
                      <p><em>Aspergillus oryzae</em>&nbsp;is incubated in a stock solution for about 4 days to form a transformant
                        culture.&nbsp;</p>
                    </li>
                  </ol>
                } />
                
              </section>
              <section id="Preparing_">
                <Accordion heading={<>Preparing protoplasts</>} content={
                  <ol start={2}>
                    <li>
                      <p>The transformant culture is filtered with a cotton-stopped syringe to obtain the solid portion, which
                        contains the mycelium.&nbsp;</p>
                    </li>
                    <li>
                      <p>The mycelial portion of the fungus is transferred into TF solution 1, a solution that digests the
                        cell wall of the fungus. The solution is incubated in a water bath for approximately 2 hours with a
                        shaking rotation.&nbsp;</p>
                    </li>
                    <li>
                      <p>The solution is filtered for the aqueous part and centrifuged.&nbsp;</p>
                    </li>
                    <li>
                      <p>The supernatant of the solution is discarded.&nbsp;</p>
                    </li>
                    <li>
                      <p>TF solution 2 is added to resuspend the deposit. The solution is shaked and centrifuged.&nbsp;</p>
                    </li>
                    <li>
                      <p>The supernatant of the solution is discarded, and TF solution 2 is added again.&nbsp;</p>
                    </li>
                    <li>
                      <p>A small amount of the resuspended culture is taken and loaded onto a count slide to count the number
                        of spores, to ensure the culture confluency is high enough for transformation.&nbsp;</p>
                    </li>
                  </ol>
                } />
                

              </section>
              <section id="Transformation">

                <Accordion heading={<>Transformation</>} content={
                  <ol start={9}>
                    <li>
                      <p>Cas9+gRNA ribonucleoprotein complexes (RNPS) is assembled&nbsp;in vitro</p>
                    </li>
                    <li>
                      <p>A part of the suspension is mixed with RNPS and plasmid solutions.&nbsp;</p>
                    </li>
                    <li>
                      <p>The solution is cultured at room temperature for approx. 30 minutes.&nbsp;</p>
                    </li>
                    <li>
                      <p>TF solution 3 is added into the culture in 3 separate times slowly and mixed.&nbsp;</p>
                    </li>
                    <li>
                      <p>The solution is cultured at room temperature for approx. 30 minutes and 5 ml of TF solution 2 is
                        added.&nbsp;</p>
                    </li>
                    <li>
                      <p>The mixture is centrifuged.&nbsp;</p>
                    </li>
                    <li>
                      <p>The supernatant is removed and the deposit is resuspended with TF solution 2.&nbsp;</p>
                    </li>
                    <li>
                      <p>5 ml CD medium (top layer) at about 40℃ is added and gently mixed.&nbsp;</p>
                    </li>
                    <li>
                      <p>The mixture is taken onto CD medium plates and incubated at 30℃ for about 4 days.&nbsp;</p>
                    </li>
                  </ol>
                } />
                

              </section>
              <br />
              <br />
               
              <section id="ANTICANCER">
                <p>
                  <h1>ANTICANCER Experiments</h1>
                  <strong>Overview</strong></p>
                <p>
                  The anticancer potential of the two novel compounds (e.g., Compound 1 & 2) from Aspergillus oryzae was investigated against the cancer cells in vitro.
                </p>
                <p><strong>MTT assay (in vitro)</strong> will be performed to test the anticancer activity of compounds <strong>1</strong> and <strong>2</strong> in the colon and ovarian cancer cells. MTT assay, a colorimetric method, measures cell viability or the cytotoxicity of the compounds, and it would be used to find the most efficient anticancer compound.</p>
                <p>
                  <a href="https://static.igem.wiki/teams/4154/wiki/assets/protocol-mtt-assay-in-vitro-secure-igem-2022.pdf" target="_blank" className="Download">Download the protocol of MTT assay (in vitro) </a>
                </p>
                <br />
                <br />

              </section>

              <section id="Design">

                <h1>
                  Design of future in vivo experiments
                </h1>
                <p>
                  <img src="https://static.igem.wiki/teams/4154/wiki/assets/toxicity-1st-one.svg" alt="" />
                </p>
                
                  <p><strong>All experiments will be conducted according to approved ethical guidelines and protocols (HKSAR, Department of Health). </strong></p>
                  <ul>
                    <li>Mice will be housed in grouped cages in a temperature-controlled environment with food and water ad libitum.&nbsp;</li>
                    <li>BALB/c mice (male and female) will be inoculated with <strong>CT26 murine colorectal cancer cell line.</strong> When tumors are already palpable, mice will be randomly divided into three groups (eight mice per group).&nbsp;</li>
                    <li>Lead drug candidate will be administered via an intraperitoneal injection after the tumors reach 1 cm in diameter (day 0). The vehicle group will receive a solution containing the equivalent amount of cremophore and ethanol used in treatment groups.&nbsp;</li>
                    <li>Mice in the positive control group will be treated with secalonic acid.&nbsp;</li>
                    <li>The volume (mm3 ) of the tumor will be calculated according to the formula:&nbsp;</li>
                  </ul>
                  
                  <p style={{textAlign:'center'}}><strong><em>tumor volume = (longest diameter) &times; (shortest diameter) /2 &times; 0.5. </em></strong><strong><em><br /><br /></em></strong></p>
                  <ul>
                    <li>The mice will be euthanized after tumors reach 2000mm3. After sacrificing, tumors and organs (liver, kidney, lungs, gut, heart) will be harvested for further evaluation.&nbsp;</li>
                    <li>All samples will be snap-frozen after the collection and then kept at -80oC till the actual experiments.</li>
                  </ul>
                  <br />
                  
                  <p>For in vivo data, the significance of differences will be evaluated with two-way ANOVA followed by Tukey&rsquo;s Multiple Comparison post-test. Statistical analysis will be executed with GraphPad Prism Software (San Diego, CA, USA), using p &lt; 0.05 as the critical level of significance.</p>

                  <img src="https://static.igem.wiki/teams/4154/wiki/assets/efficacy-2nd-one.svg" alt="" />

                <p>In the future drug toxicity experiment, BALB/c mice will be obtained from the Laboratory Animal Research Center, City University of Hong Kong, and handled with protocols approved by the Laboratory Animal Ethics Committee of the Department of Health, HKSAR.&nbsp;</p>
                <ul>
                  <li>BALB/c mice will be obtained at eight weeks of age and housed 5 per cage in a 12 h/12 h light/dark cycle.&nbsp;</li>
                  <li>All animals will be fed with water and standard laboratory chow.&nbsp;</li>
                  <li>The mice will be randomly divided into three groups (8 mice/per group) and injected intraperitoneally with different concentrations of a leading drug candidate (25mg/kg, 10mg/kg).&nbsp;</li>
                  <li>The vehicle group will receive PBS with solvents used in actual drug preparation.&nbsp;</li>
                  <li>The mice will be weighed and evaluated for behavioral changes at different periods after injection (0 to 30 days).</li>
                </ul>
                <p>For in vivo data, the significance of differences will be evaluated with two-way ANOVA followed by Tukey&rsquo;s Multiple Comparison post-test. Statistical analysis will be executed with GraphPad Prism Software (San Diego, CA, USA), using p &lt; 0.05 as the critical level of significance.</p>
                <br />
                <br />
              </section>
              
            </div>


            
          </div>
        </div>
      </section>
    </div>
  );
}

export default Experiments;
